export const rootRoute = () => '/'
export const subjectsListRoute = () => '/'
export const loginRoute = () => '/login'
export const logoutRoute = () => '/logout'
export const subjectCreateRoute = () => '/subject/create'
export const subjectConfirmRoute =
  (subjectIdentifier: string = ':subjectIdentifier') => `/subjects/${subjectIdentifier}/confirm`
export const subjectShowRoute = (subjectIdentifier: string = ':subjectIdentifier') => `/subjects/${subjectIdentifier}`
export const prescriptionCreateRoute =
  (subjectIdentifier: string = ':subjectIdentifier') => `/subjects/${subjectIdentifier}/prescription/create`
export const prescriptionUpdateRoute =
  (subjectIdentifier: string = ':subjectIdentifier') => `/subjects/${subjectIdentifier}/prescription/update`



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_coordinator/src/routes.ts